export function KeywordHint() {
  return (
    <div className="mt-3 rounded-lg bg-muted/50 px-3 pt-3 pb-10">
      <p className="mb-0 flex items-center font-medium text-sm text-foreground">
        <span>参考：</span>
        <span className="relative border-b border-pink">
          <span>3分程度</span>
          <span
            aria-hidden="true"
            className="absolute flex justify-center w-full pt-1 overflow-visible select-none pointer-events-none"
          >
            <span className="text-sm text-pink whitespace-nowrap font-normal">
              曲の長さ
            </span>
          </span>
        </span>
        <span className="mx-0.5">の</span>
        <span className="relative border-b border-pink">
          <span>新曲のミックスマスタリング</span>
          <span
            aria-hidden="true"
            className="absolute flex justify-center w-full pt-1 overflow-visible select-none pointer-events-none"
          >
            <span className="text-sm text-pink whitespace-nowrap font-normal">
              依頼のカテゴリ
            </span>
          </span>
        </span>
        <span>をお願いしたい。</span>
      </p>
    </div>
  )
}
